import { render, staticRenderFns } from "./WholesalePriceList.vue?vue&type=template&id=2363d958&scoped=true"
import script from "./WholesalePriceList.vue?vue&type=script&lang=js"
export * from "./WholesalePriceList.vue?vue&type=script&lang=js"
import style0 from "./WholesalePriceList.vue?vue&type=style&index=0&id=2363d958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363d958",
  null
  
)

export default component.exports